import React from "react";
import BannerComponent from "../BannerComponent/BannerComponent";

const HomeComponent = () => {
  return (
    <main>
      <BannerComponent />
    </main>
  );
};

export default HomeComponent;
